var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSubwayError = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20730_141175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 .5a7 7 0 0 0-7 7 7 7 0 0 0 7 7 7 7 0 0 0 7-7 7 7 0 0 0-7-7Zm-5.25 7A5.25 5.25 0 0 1 7 2.25c1.151 0 2.215.375 3.079 1.004l-7.325 7.325A5.216 5.216 0 0 1 1.75 7.5ZM7 12.75a5.216 5.216 0 0 1-3.079-1.004l7.325-7.325A5.222 5.222 0 0 1 12.25 7.5 5.25 5.25 0 0 1 7 12.75Z",
    fill: "#ff7384"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20730_141175"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgSubwayError;